import "./styles.scss";

import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { postResendContract } from "../../../store/middleware";

function ModalModalPendingContract({ showModal, setShowModal, setShowTaxInformation }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const handleUpdate = () => {
    setShowModal(false);
    setShowTaxInformation(true);
  };

  const handleResend = () => {
    dispatch(postResendContract(affiliateInfo?.id)).then((resp) => {
      if (resp) {
        alert(t("ALERT_MESSAGE_TAX_INFORMATION"));
        setShowModal(false);
      }
    });
  };

  return (
    <Dialog
      open={showModal}
      className="modalPrivilege"
      onClose={() => setShowModal(false)}
      aria-labelledby="alert-dialog-title"
      classes={"modalContainerPendingContract"}
      aria-describedby="alert-dialog-description"
    >
      <div className="containerPendingContract">
        <h3 className="title">{t("CONTRACT_PENDING")}</h3>

        <form className="contentPaymentInformation">
          <h4>{t("ALERT_MESSAGE_TAX_INFORMATION")}</h4>

          <div className="wrapperButton">
            <button type="button" className="buttonUpdate" onClick={handleUpdate}>
              {t("UPDATE_SCREEN")}
            </button>
            <button type="button" className="buttonResend" onClick={handleResend}>
              {t("RESEND")}
            </button>
          </div>
        </form>

        <div className="footer">
          <button className="buttonModalSave" onClick={() => setShowModal(false)}>
            {t("BTN_CLOSE")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalModalPendingContract;
